import React from 'react';
import ReactDOM from 'react-dom';
import 'what-input';
import App from './App';

__webpack_public_path__ = `${window.UI_PATH}/`;

export const render = () => {
  const rootElement = document.querySelector('.main-wrapper');
  ReactDOM.render(<App />, rootElement);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    render();
  });
} else {
  render();
}
